import XEUtils from 'xe-utils'
import {reportYear} from '../../util/util'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
import { validRange } from 'semver'
Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      event_property_list: [
        {'key': '负向', 'value': -1},
        {'key': '正向', 'value': 1},
        {'key': '不明', 'value': 0},
      ],
      sentiment:{
        '-1':'负面',
        '0':'中性',
        '1':'正面'
      },
      sentiment_level:null,
      entityCount: 0,
      loading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pagerCount: 3,
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true
      },
      data: [],
      exportConfig: {},
      sub_type: '',
      sub_type_name:null,
      publish_start_date: null,
      publish_end_date: null,
      start_date: null,
      end_date: null,
      oaid: null,
      subject_oaid: null,
      impact_level: null,
      endOpen: false,
      publishendOpen: false,
      issuer_type: '',
      issuer_type_name:null,
      gics_name:"",
      gics: null,
      gics_option:null,
      gics_industry: '',
      nei_industry: ' ',
      national_economic: null,
      gics_options: null,
      national_economic_options: null,
      national_economic_option:null,
      columns2: [],
      company_name:"",
      subject_company_name:"",
      follow_oaid: false,
      follow_subject_oaid: false,
      filterItems: {},
      nei_code_industry: []
    }
  },
  methods: {
    tagClose(tagType) {
      if(tagType === 'sub_type') {
        this[tagType] = ""
      } else if (tagType === 'gics') {
        this.gics_option = [""]
        this.gics = null
      } else if (tagType === 'national_economic') {
        this.national_economic_option = [""]
        this[tagType] = ''
      } else if (tagType === 'oaid') {
        this.$refs.company.clear()
        this.company_name = null
      } else if (tagType === 'subject_oaid') {
        this.$refs.subject_company.clear()
        this.subject_company_name = null
      } else {
        this[tagType] = null
      }
      this.$nextTick(() => {
        delete this.filterItems[tagType]
        this.filterItems = {...this.filterItems}
      })
    },
    pushData(filterType) {
      if(filterType === 'sub_type') {
        if (this.sub_type !== '') {
          this.filterItems[filterType] = this.sub_type_name
        } else {
          delete this.filterItems[filterType]
        }
      } else if (filterType === 'gics') {
        this.filterItems[filterType] = this.getGicsName(this.gics)
      } else if (filterType === 'issuer_type') {
        this.filterItems[filterType] = this.getIssuerType(this.issuer_type)
      } else if (filterType === 'sentiment_level') {
        let sentiment_zh = ''
        this.sentiment_list.map((item)=>{
        if(item.value!==null&&item.value===this.sentiment_level){
          sentiment_zh=item.key
        }
        })
        if (sentiment_zh !== '') {
          this.filterItems[filterType] = sentiment_zh
        } else {
          delete this.filterItems[filterType]
        }
      } else if (filterType === 'oaid') {
        this.$nextTick(() => {
          if (this.company_name !== '') {
            this.filterItems[filterType] = '事件关联公司名称：'+this.company_name
          } else {
            delete this.filterItems[filterType]
          }
        })
      } else if (filterType === 'subject_oaid') {
        this.$nextTick(() => {
          if (this.subject_company_name !== '') {
            this.filterItems[filterType] = '事件发生主体名称：'+this.subject_company_name
          } else {
            delete this.filterItems[filterType]
          }
        })
      } else if (filterType === 'start_date' || filterType === 'publish_start_date' || filterType === 'publish_end_date' || filterType === 'end_date' ) {
        let dateMap = {
          'start_date': '事件发生开始日期：',
          'publish_start_date': '事件披露开始日期：',
          'publish_end_date': '事件披露结束日期：',
          'end_date': '事件发生结束日期：'
        }
        if (this[filterType]) {
          this.filterItems[filterType] = dateMap[filterType]+this.timestampToTime(this[filterType]._d)
        }
      } else if (filterType === 'follow_subject_oaid') {
        if(this.follow_subject_oaid) {
          this.filterItems[filterType] =  '事件发生主体名称：关注公司'
        } else {
          delete this.filterItems[filterType]
        }
      } else if (filterType === 'follow_oaid') {
        if(this.follow_oaid) {
          this.filterItems[filterType] =  '事件关联公司名称：关注公司'
        } else {
          delete this.filterItems[filterType]
        }
      } else if (filterType === 'national_economic') {
        const row = this.nei_code_industry.find(item => item.code === this.national_economic)
        if (row) this.filterItems[filterType] = row.name
      } else {
        if (this[filterType]) {
          this.filterItems[filterType] = this[filterType]
        } else {
          delete this.filterItems[filterType]
        }
      }
      this.$nextTick(() => {
        this.filterItems = {...this.filterItems}
      })
    },
    disabledPublishStartDate(start_date) {
      let end_date = this.publish_end_date;
      if (!start_date || !end_date) {
        return false;
      }
      return start_date.valueOf() > end_date.valueOf();
    },
    disabledPublishEndDate(end_date) {
      let start_date = this.publish_start_date;
      if (!end_date || !start_date) {
        return false;
      }
      return start_date.valueOf() >= end_date.valueOf();
    },
    handlePublishStartOpenChange(open) {
      if (!open) {
        this.publishendOpen = true;
      }
    },
    handlePublishEndOpenChange(open) {
      this.publishendOpen = open;
    },
    disabledStartDate(start_date) {
      const end_date = this.end_date;
      if (!start_date || !end_date) {
        return false;
      }
      return start_date.valueOf() > end_date.valueOf();
    },
    disabledEndDate(end_date) {
      const start_date = this.start_date;
      if (!end_date || !start_date) {
        return false;
      }
      return start_date.valueOf() >= end_date.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    openDataExport() {
      let s = "ESG事件"
      this.$refs.xTable_data.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv']
      })
    },
    pageChange({currentPage, pageSize}) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getEsgEvent()
    },

    // 双方公用
    bothGics_Nation_Filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    // 事件关联所处行业选项框
    gicsOnChange(value, selectedOptions) {
      this.gics = value[value.length-1]
    },
    // 事件发生主体所处行业选项卡
    nationalEconomicOnChange(value, selectedOptions) {
      this.national_economic = value[value.length-1]
    },
    getGicsIndustries() {
      let self = this
      let lang = this.$i18n.locale
      reportYear.gics("gics_tree_" + lang).then(result => {
        self.gics_options = result
      })
    },
    getNationalIndustries() {
      let self = this
      reportYear.national_economic("nei_code").then(result => {
        self.national_economic_options = result
      })
    },

    getEsgEvent() {
      let self = this
      self.loading = true
      self.data = []
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      if (self.sub_type){
        params.set("sub_type", self.sub_type)
      }
      if (self.publish_start_date)
        params.set("publish_date_from", self.publish_start_date.format('YYYY-MM-DD'))
      if (self.publish_end_date)
        params.set("publish_date_to", self.publish_end_date.format('YYYY-MM-DD'))
      if (self.start_date)
        params.set("date_from", self.start_date.format('YYYY-MM-DD'))
      if (self.end_date)
        params.set("date_to", self.end_date.format('YYYY-MM-DD'))
      if (self.oaid)
        params.set("oaid", self.oaid)
      if (self.subject_oaid)
        params.set("subject_oaid", self.subject_oaid)
      if (self.impact_level)
        params.set("impact_level", self.impact_level)
      if (self.issuer_type){
        params.set("issuer_type", self.issuer_type)
      }
      if(self.gics) {
        params.set("gics", self.gics)
      }
      if(self.national_economic) {
        params.set("ne_code", self.national_economic)
      }
      if(self.sentiment_level!==null){
        params.set("sentiment",self.sentiment_level)
      }
      
      params.set('follow_oaid', self.follow_oaid)
      params.set('follow_subject_oaid', self.follow_subject_oaid)
      httpManager("esg_event_raw", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          let page = response.data.page
          this.page.total = page.total

          let gics_industry = JSON.parse(window.sessionStorage.getItem('gics_tree_zh'))
          let national_industry = JSON.parse(window.sessionStorage.getItem('nei_code_industry'))

          for(let i in self.data) {
            for( let k in gics_industry) {
              let name1 = gics_industry[k].label
              if(self.data[i].gics_code == gics_industry[k].value) {
                self.data[i]['gics_industry'] = name1
                continue
              }
              for(let j in gics_industry[k].children) {
                if(self.data[i].gics_code == gics_industry[k].children[j].value) {
                  let name = name1 + '/' + gics_industry[k].children[j].label
                  self.data[i]['gics_industry'] = name
                }
              }
            }
          }
          let obj = {}
          for( let i in national_industry) {
            if(national_industry[i].class_1&& !national_industry[i].class_2) {
              obj[national_industry[i].class_1] = national_industry[i].name
            }
          }
          for(let i in self.data) {
            for( let k in national_industry) {

              let name = national_industry[k].name
              let top = national_industry[k].code.slice(0,1)
              let name1 = obj[top]
              if(self.data[i].national_economic_code == national_industry[k].code) {
                self.data[i]['nei_industry'] = name1+ '/' + name
              }
            }
          }
          self.loading = false
        })
        .catch(error => {
          self.loading = false
        })
    },

    // 清除筛选条件
    clearContent(){
      this.sub_type = ''
      this.impact_level=null
      this.publish_start_date=null
      this.publish_end_date=null
      this.start_date=null
      this.end_date=null
      this.issuer_type=''
      this.oaid=undefined
      this.subject_oaid=null
      this.gics=undefined
      this.national_economic=null
      this.company_name=null
      this.gics_option=[""]
      this.national_economic_option=[""]
      this.$refs.company.company_name=''
      this.subject_company_name=null
      this.$refs.subject_company.company_name=''
      this.sentiment_level=null
      this.follow_oaid = false
      this.follow_subject_oaid = false
      this.$nextTick(() => {
        this.filterItems = {}
      })
    },

    //时间戳转换成标准时间
    timestampToTime(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      return Y+M+D;
    },

    // 根据行业对应的编号找到对应的名字
    getGicsName(gics){
      let gics_industry = JSON.parse(window.sessionStorage.getItem('gics_tree_zh'))
      for(let item of gics_industry){
          if(gics==item['value']){
              return item['label']
          }
          if(item.children){
              for(let sub_item of item.children){
                  if(gics==sub_item['value']){
                      return sub_item['label']
                  }
              }
          }
      }
    },

    // 得到sub_type对应的名字
    getEventType(cellValue){
      let dict={
        'EnvPunishment':'环境处罚',
        'BankInsurancePunishment':'金融监管处罚',
        'WorkSafetyPunishment':'安全生产处罚',
        'WorkSafetyIncident':'安全生产事故',
        'ProductRecall':'产品召回',
        'UnannouncedInspection':'飞行检查',
        'MarketPunishment':'市场监管处罚',
        'AntiCorruption':'反腐',
        'ProductInspection':'产品抽检',
        'EnvImpactAssessment':'环境影响评价',
        'Announcement':'供应链',
        'SecurityPunishment':'证监会处罚',
        'SecurityRegulatory':'证监会监管措施',
        'ExchangeRegulatory':'交易所监管',
        'FinancialMarketInstitutionRegulatory':'交易商协会监管',
        'NaturalResourcePunishment':'自然资源处罚',
        'TaxationPunishment':'税务处罚',
      }
      return dict[cellValue]
    },

    // 得到对应的证券机构类型名字
    getIssuerType(target){
      let dict={'ticker':'上市公司','bond':'发债主体'}
      if(target in dict){
        return dict[target]
      }
      if(target==''){
        return '不限'
      }
    },
    async getEntityName() {
      let params = new Map()
      params.set('oaid', this.oaid)
      const res = await httpManager('entity_basic_info', params)
      this.company_name = res.data.data['entname']
      this.$refs.company.company_name = this.company_name
      this.$refs.company.closeClick = true
      this.pushData('oaid')
    }
  },
  mounted() {
    this.nei_code_industry = JSON.parse(sessionStorage.getItem('nei_code_industry'))
    this.oaid = this.$route.params.oaid
    this.getEntityName()
    this.$nextTick(() => {
      this.columns2 = this.$refs.xTable_data.getColumns()
    })
    this.getGicsIndustries()
    this.getNationalIndustries()
    this.getEsgEvent()
  },
  watch: {
    sub_type() {
      this.sub_type_name = this.getEventType(this.sub_type)
      this.pushData('sub_type')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    publish_start_date() {
      this.pushData('publish_start_date')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    publish_end_date() {
      this.pushData('publish_end_date')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    start_date() {
      this.pushData('start_date')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    end_date() {
      this.pushData('end_date')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    oaid() {
      if (this.oaid !== undefined) {
        this.pushData('oaid')
      }
      this.company_name=this.$refs.company.company_name
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    subject_oaid() {
      this.pushData('subject_oaid')
      this.subject_company_name=this.$refs.subject_company.company_name
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    impact_level() {
      this.pushData('impact_level')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    issuer_type() {
      this.pushData('issuer_type')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    gics() {
      this.pushData('gics')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    national_economic() {
      this.pushData('national_economic')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    sentiment_level() {
      this.pushData('sentiment_level')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    follow_oaid() {
      this.pushData('follow_oaid')
      this.page.currentPage = 1
      this.getEsgEvent()
    },
    follow_subject_oaid() {
      this.pushData('follow_subject_oaid')
      this.page.currentPage = 1
      this.getEsgEvent()
    }
  },
  computed: {
    event_type_list() {
      return [
        {'label': this.$t('event.all'), 'value': ''},
        {'label': this.$t('event.environmental_penalty'), 'value': 'EnvPunishment'},
        {'label': this.$t('event.environmental_impact_assessment'), 'value': 'EnvImpactAssessment'},
        {'label': this.$t('event.financial_supervision_punishment'), 'value': 'BankInsurancePunishment'},
        {'label': this.$t('event.work_safety_accident'), 'value': 'WorkSafetyIncident'},
        {'label': this.$t('event.work_safety_penalty'), 'value': 'WorkSafetyPunishment'},
        {'label': this.$t('event.product_sampling'), 'value': 'ProductInspection'},
        {'label': this.$t('event.product_recal'),'value':'ProductRecall'},
        {'label': this.$t('event.market_supervision_penalty'), 'value': 'MarketPunishment'},
        {'label': this.$t('event.flight_check'), 'value': 'UnannouncedInspection'},
        {'label': this.$t('event.anticorruption'), 'value': 'AntiCorruption'},
        {'label': this.$t('event.supply_chain'), 'value': 'Announcement'},
        {'label': this.$t('event.security_punishment'), 'value': 'SecurityPunishment'},
        {'label': this.$t('event.security_regulatory'), 'value': 'SecurityRegulatory'},
        {'label': this.$t('event.exchange_regulatory'), 'value': 'ExchangeRegulatory'},
        {'label': this.$t('event.fmi_regulatory'), 'value': 'FinancialMarketInstitutionRegulatory'},
        {'label': this.$t('event.natural_resource_punishment'), 'value': 'NaturalResourcePunishment'},
        {'label': this.$t('event.taxation_punishment'), 'value': 'TaxationPunishment'},
      ]
    },
    tableColumn() {
      return [
        {type: 'seq', width: 50},
        {
          title: this.$t('event.event_child_type'), field: "sub_type",
          formatter: ({cellValue}) => {
            if ('EnvPunishment' == cellValue)
              return '环境处罚'
            if ('BankInsurancePunishment' == cellValue)
              return '金融监管处罚'
            if ('WorkSafetyPunishment' == cellValue)
              return '安全生产处罚'
            if ('WorkSafetyIncident' == cellValue)
              return '安全生产事故'
            if ('ProductRecall' == cellValue)
              return '产品召回'
            if ('UnannouncedInspection' == cellValue)
              return '飞行检查'
            if ('MarketPunishment' == cellValue)
              return '市场监管处罚'
            if ('AntiCorruption' == cellValue)
              return '反腐'
            if ('ProductInspection' == cellValue)
              return '产品抽检'
            if ('EnvImpactAssessment' == cellValue)
              return '环境影响评价'
            if ('Announcement' == cellValue)
              return '供应链'
            if ('SecurityPunishment' == cellValue)
              return '证监会处罚'
            if ('SecurityRegulatory' == cellValue)
              return '证监会监管措施'
            if ('ExchangeRegulatory' == cellValue)
              return '交易所监管'
            if ('FinancialMarketInstitutionRegulatory' == cellValue) 
              return '交易商协会监管'
            if ('NaturalResourcePunishment' == cellValue) 
              return '自然资源处罚'
            if ('TaxationPunishment' == cellValue) 
              return '税务处罚'
            return ''
          }
        },
        {title: this.$t('event.stock_code'), field: "ticker"},
        {title: this.$t('event.stock_short_name'), field: "short_name"},
        {title: this.$t('event.bond_issue'), field: "bond", titleHelp: { message: '债[x, y, z]中三个数字分别代表：银行间债券数；交易所债券数；存续数' }},
        {title: this.$t('event.associated_event_company_name'), field: "full_name"},
        {title: this.$t('event.associated_event_company_industry'), field: "gics_industry", formatter: ({cellValue}) => {
          return cellValue?cellValue: ''
          }},
        {title: this.$t('event.occurrence_principal_event_name'), field: "subject_name"},
        {title: this.$t('event.occurred_event_industry'), field: "nei_industry", formatter: ({cellValue}) => {
          return cellValue?cellValue: ''
          }},
        {title: this.$t('event.equity_correlation_degree'), field: "shareholding_level"},
        {title: this.$t('event.regulator'), field: "content.bureau"},
        {title: this.$t('event.document_id'), field: "content.doc_id"},
        {title: this.$t('event.event_publish_date'), field: "publish_date"},
        {title: this.$t('event.event_happen_date'), field: "date"},
        {title: this.$t('event.irregularity'), field: "content.fact", showOverflow: 'tooltip'},
        {title: this.$t('event.punishment_type'), field: "content.supervision_category"},
        {
          title: this.$t('event.amount'), field: "fine", formatter: ({cellValue}) => {
            return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''
          }
        },
        {title:this.$t('event.sentiment'),field:'sentiment',formatter:({cellValue}) =>{
          return this.sentiment[cellValue]
        }},
        {title: this.$t('event.event_impact_level'), field: "impact_level"},
        {title: this.$t('event.source_link'), field: "url", slots: {default: 'num_default'}},
      ]
    },
    event_impact_level_list() {
      return [
        {'key': this.$t('event.all'), 'value': null},
        {'key': '1', 'value': 1},
        {'key': '2', 'value': 2},
        {'key': '3', 'value': 3},
        {'key': '4', 'value': 4},
      ]
    },
    sentiment_list(){
      return [
        {'key': this.$t('event.all'), 'value': null},
        {'key': '负面', 'value': -1},
        {'key': '中性', 'value': 0},
        {'key': '正面', 'value': 1},
      ]
    },
  }
}
Vue.component("event-home", vm)
export default vm



// WEBPACK FOOTER //
// ./src/event/js/event_home.js